export default __webpack_public_path__ + "static/media/Screenshot_19.d85cb584.png";